import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useRef, useState } from "react";
import CustomBreadcrumb from "../../components/CustomBreadcrumb";
import FormItemInput from "../../components/form-item/form-item-input";
import FormItemInputSelect from "../../components/form-item/form-item-input-select";
import { Form } from "antd";
import FormCard from "../../components/card/FormCard";
import ImageCard from "../../components/card/ImageCard";
import FormItemInputTextarea from "../../components/form-item/form-item-input-textarea";
import FormButton from "../../components/FormButton";
import { useNotify } from "../../helper/notify";
import { GetFullMediaPath, requireRules } from "../../helper/method";
import { langMock, statusShowMock, tokenMock } from "../../helper/mock";
import PreviewFile from "../../components/PreviewFile";
import { $api } from "../../helper";
import { useNavigate, useSearchParams } from "react-router";
import Quill from "quill";

export default function AddBlog() {
  const [form] = Form.useForm();
  const [searchParams] = useSearchParams();
  const notify = useNotify();
  const editorRef = useRef<HTMLDivElement | null>(null);
  const quillRef = useRef<Quill | null>(null);
  const navigate = useNavigate();
  const u_id = searchParams.get("u_id");
  const { mutate, isPending } = $api.useMutation("post", "/site-api/v1/blog/");
  const update = $api.useMutation("put", "/site-api/v1/blog/");
  const detail = $api.useMutation("get", "/site-api/v1/blog-detail/");
  const getCategory = $api.useQuery("get", "/site-api/v1/blog/category/");
  const [file, setFile] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const [fileMobile, setFileMobile] = useState<
    {
      file: File | undefined;
      fileUrl: string;
      id: string;
    }[]
  >([]);
  const { setDashboardName } = useStore(useDashboardName);
  useEffect(() => {
    setDashboardName("ایجاد مقاله");
    if (u_id) {
      detail.mutate({
        params: {
          query: {
            blog_u_id: u_id ?? "",
          },
        },
        headers: {
          Authorization: tokenMock,
          lang: "fa",
        },
      });
    }
  }, []);

  useEffect(() => {
    if (!editorRef.current) return;

    if (quillRef.current) return;

    quillRef.current = new Quill(editorRef.current, {
      theme: "snow",
      modules: {
        toolbar: [
          [{ header: [1, 2, 3, 4, 5, 6, false] }],
          ["bold", "italic", "underline", "strike"],
          [{ color: [] }, { background: [] }],
          [{ direction: "rtl" }],
          [{ align: [] }],
          ["link"],
          ["clean"],
        ],
      },
    });
  }, []);

  useEffect(() => {
    if (detail.data?.data) {
      setFile([
        {
          file: undefined,
          fileUrl: GetFullMediaPath(detail.data.data.image_desktop),
          id: detail.data.data.u_id,
        },
      ]);
      setFileMobile([
        {
          file: undefined,
          fileUrl: GetFullMediaPath(detail.data.data.image_mobile),
          id: detail.data.data.u_id,
        },
      ]);
      Object.entries(detail.data?.data).forEach(([key, value]) => {
        form.setFieldValue(key, value?.toString());
      });
      quillRef.current?.clipboard.dangerouslyPasteHTML(
        detail.data.data.content,
      );
      Object.entries(detail.data?.data).forEach(([key, value]) => {
        form.setFieldValue(key, value?.toString());
      });
    }
  }, [detail.data]);

  useEffect(() => {
    if (quillRef.current) {
      quillRef.current.format("align", "right");
      quillRef.current.on("text-change", () => {
        const value =
          Number(quillRef.current?.editor.delta.ops[0].insert?.length) <= 1
            ? ""
            : quillRef.current && quillRef.current.root.innerHTML;

        form.setFieldValue("content", value);
        form.validateFields(["content"]);
      });
    }
  }, [quillRef.current?.editor.getText]);

  const onFinish = (
    values: {
      title: string;
      status: string;
      seo_title: string;
      seo_description: string;
      language: string;
      description: string;
      category_u_id: string;
      slug: string;
    },
    redirect = true,
  ) => {
    const formData = new FormData();
    formData.append("title", values.title);
    formData.append("slug", values.slug);
    formData.append("status", values.status);
    formData.append("seo_title", values.seo_title);
    formData.append("seo_description", values.seo_description);
    formData.append("language", values.language);
    formData.append("description", values.description);
    formData.append("content", form.getFieldValue("content"));
    formData.append("category_u_id", values.category_u_id);
    formData.append(
      "image_desktop",
      file?.at(0)?.file ?? file?.at(0)?.fileUrl ?? "",
    );
    if (u_id) {
      formData.append("blog_u_id", u_id);
    }
    formData.append(
      "image_mobile",
      fileMobile?.at(0)?.file ?? fileMobile?.at(0)?.fileUrl ?? "",
    );
    if (!u_id) {
      mutate(
        {
          body: formData,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/blog");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    } else {
      update.mutate(
        {
          body: formData,
          headers: {
            Authorization: tokenMock,
            lang: "fa",
          },
        },
        {
          onSuccess: (data) => {
            notify.success(data.message);
            if (redirect) {
              navigate("/blog");
            } else {
              setTimeout(() => {
                window.location.href = window.location.pathname;
              }, 1000);
            }
          },
        },
      );
    }
  };

  return (
    <Form
      form={form}
      onFinish={(e) => onFinish(e, true)}
      layout="vertical"
      className="flex! flex-col! gap-6!"
    >
      <CustomBreadcrumb
        items={[
          {
            title: "اخبار مقالات",
            href: "/blog",
          },
          {
            title: "ایجاد مقاله",
          },
        ]}
      />
      <CustomBreadcrumb
        first="اخبار مقالات"
        second="لیست مقالات"
        third="ایجاد مقاله جدید"
      />
      <FormCard
        subTitle="تعریف و تنظیمات پایه مربوط به مقاله"
        title="اطلاعات اصلی مقاله"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInput
            name={"title"}
            rules={requireRules("نام مقاله")}
            className="col-span-1"
            label="نام مقاله"
            inputProps={{
              placeholder: "لطفا نام مقاله خود را وارد کنید.",
            }}
          />
          <FormItemInput
            name={"slug"}
            rules={requireRules("اسلاگ")}
            className="col-span-1"
            label="اسلاگ"
            inputProps={{
              placeholder: "لطفا نام اسلاگ خود را وارد کنید.",
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            rules={requireRules("دسته بندی")}
            name={"category_u_id"}
            label="دسته بندی"
            inputProps={{
              placeholder: "لطفا دسته بندی بلاگ خود را انتخاب کنید.",
              options: getCategory.data?.data?.map((e) => ({
                label: e.title,
                value: e.u_id,
              })),
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            rules={requireRules("وضعیت")}
            name={"status"}
            label="وضعیت"
            inputProps={{
              placeholder: "لطفا وضعیت نمایش بلاگ خود را انتخاب کنید.",
              options: statusShowMock,
            }}
          />
          <FormItemInputSelect
            className="col-span-1"
            rules={requireRules("زبان")}
            name={"language"}
            label="زبان"
            inputProps={{
              placeholder: "لطفا زبان نمایش بلاگ خود را انتخاب کنید.",
              options: langMock,
            }}
          />
        </div>
      </FormCard>
      <FormCard subTitle="توضیح کوتاه و کامل بلاگ" title="توضیحات بلاگ">
        <div className="grid grid-cols-2 w-full gap-6">
          <FormItemInputTextarea
            rules={requireRules("توضیحات کوتاه اجباری میباشد")}
            name={"description"}
            className="col-span-2"
            label="توضیحات کوتاه"
            inputProps={{
              placeholder: "توضیحات مختصر...",
              rows: 8,
            }}
          />
          <Form.Item
            rules={requireRules("توضیحات کامل اجباری میباشد")}
            className="col-span-2"
            name="content"
            label="توضیحات کامل"
          >
            <div
              dir="auto"
              className="w-full border-r border-l border-b border-grayscale-200 h-96! rounded-br-xl rounded-bl-xl"
              lang="fa"
              ref={editorRef}
            />
          </Form.Item>
        </div>
      </FormCard>
      <FormCard
        subTitle="تصاویر مربوط به نمایش مقاله در نسخه‌های مختلف"
        title="تصاویر مقاله"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <div className="col-span-1 flex h-fit flex-col gap-2">
            <ImageCard
              file={file}
              setFile={setFile}
              id="image1-1"
              name="desktop_image"
            />
            {file?.map((e, i) => (
              <div className="w-40 h-40">
                <PreviewFile
                  id={e.id}
                  setFile={setFile}
                  url={e.fileUrl}
                  key={"preview-category" + i}
                />
              </div>
            ))}
          </div>
          <div className="col-span-1 flex h-fit flex-col gap-2">
            <ImageCard
              mobile
              file={fileMobile}
              setFile={setFileMobile}
              id="image2-2"
              name="mobile_image"
            />
            {fileMobile?.map((e, i) => (
              <div className="w-40 h-40">
                <PreviewFile
                  id={e.id}
                  setFile={setFileMobile}
                  url={e.fileUrl}
                  key={"preview-mobile-category" + i}
                />
              </div>
            ))}
          </div>
        </div>
      </FormCard>
      <FormCard
        title="اطلاعات سئو"
        subTitle="بهینه‌سازی مقاله  برای موتورهای جستجو"
      >
        <div className="grid sm:grid-cols-2 grid-cols-1 w-full gap-6">
          <FormItemInput
            rules={requireRules("عنوان سئو")}
            name={"seo_title"}
            label="عنوان سئو"
            className="col-span-1"
            inputProps={{
              placeholder: "لطفا عنوان سئو خود را وارد کنید.",
            }}
          />
          <FormItemInputTextarea
            rules={requireRules("توضیحات سئو")}
            label="توضیحات"
            name={"seo_description"}
            className="col-span-1"
            inputProps={{
              className: "resize-none!",
              rows: 4,
              placeholder: "لطفا توضیحات اضافی سئو خود را بنویسید...",
            }}
          />
        </div>
      </FormCard>
      <FormButton
        isPending={isPending || update.isPending}
        ActionSaveAndStay={() => {
          form.validateFields().then(() => {
            onFinish(form.getFieldsValue(), false);
          });
        }}
      />
    </Form>
  );
}
